<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10.75 5.27777C10.75 4.86356 10.4142 4.52777 10 4.52777C9.58579 4.52777 9.25 4.86356 9.25 5.27777V9.99999C9.25 10.2461 9.37074 10.4766 9.57309 10.6166L13.1842 13.1166C13.5248 13.3524 13.992 13.2675 14.2278 12.9269C14.4635 12.5863 14.3786 12.1191 14.038 11.8833L10.75 9.60703V5.27777Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 1.19444C5.13684 1.19444 1.19446 5.13682 1.19446 10C1.19446 14.8632 5.13684 18.8056 10 18.8056C14.8632 18.8056 18.8056 14.8632 18.8056 10C18.8056 5.13682 14.8632 1.19444 10 1.19444ZM2.69446 10C2.69446 5.96525 5.96527 2.69444 10 2.69444C14.0348 2.69444 17.3056 5.96525 17.3056 10C17.3056 14.0347 14.0348 17.3056 10 17.3056C5.96527 17.3056 2.69446 14.0347 2.69446 10Z"
            fill="currentColor"
        />
    </svg>
</template>
